module.exports = __webpack_public_path__ + "img/5.234684a1.jpg";